<ng-template #template let-row="row">
  <div class="project-origin-cell">
    <status-reason
      [color]="row?.projectPublicFormToken ? 'dark-grey' : 'green'"
      [comment]="
        (row?.projectPublicFormToken
          ? 'ProjectsList.externalConfiguratorProject'
          : 'ProjectsList.internalConfiguratorProject'
        ) | translate
      "
      [showTooltipWithComment]="true"
    />
  </div>
</ng-template>
